import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M20.484 3.513c-4.687-4.685-12.285-4.684-16.97.003-4.686 4.687-4.685 12.285.002 16.97 4.687 4.686 12.285 4.685 16.97-.002a12 12 0 0 0-.002-16.97m-2.31 13.203-.002.001v-.003l-.608.603a3.2 3.2 0 0 1-3.02.864 10.6 10.6 0 0 1-3.088-1.384 14.3 14.3 0 0 1-2.436-1.964 14.4 14.4 0 0 1-1.82-2.208 11.2 11.2 0 0 1-1.368-2.768 3.2 3.2 0 0 1 .8-3.268l.712-.712c.198-.198.52-.2.718-.001l.002.001 2.248 2.248a.51.51 0 0 1 0 .72l-1.32 1.32c-.379.375-.426.97-.112 1.4a15.4 15.4 0 0 0 1.58 1.845c.64.643 1.336 1.227 2.08 1.748.43.3 1.012.249 1.384-.12l1.276-1.296a.51.51 0 0 1 .72 0l2.252 2.255c.199.198.2.52.002.719" }, null, -1)
  ])))
}
export default { render: render }